import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

export const ChartLegendWrapper = styled.div<{
  chartHeight: number;
  itemsCount: number;
  marginLeft?: number;
}>`
  ${props => !!props.marginLeft && `margin-left: ${props.marginLeft}px;`}
`;

const ChartLegendItem = styled.div`
  display: flex;
  gap: 8px;
  padding: 4px;
  cursor: pointer;
  width: fit-content;
`;

const ChartLegendCircle = styled.div<{ circleColor: string }>`
  aspect-ratio: 1;
  height: 1rem;
  border-radius: 50%;
  ${props => `background-color: ${props.circleColor};`}
`;

const ChartLegendLabel = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
`;

const ChartLegentContentComponent = (props: any) => {
  const {
    payload,
    chartHeight,
    onClick,
    onMouseEnter,
    onMouseLeave,
    portalRef,
    formatter,
  } = props;

  const handleClick = (payload: any) => onClick && onClick(payload);
  const handleMouseEnter = (payload: any, index: number) =>
    onMouseEnter && onMouseEnter(payload, index);
  const handleMouseLeave = (payload: any, index: number) =>
    onMouseLeave && onMouseLeave(payload, index);

  const renderInPortal = (children: any) =>
    portalRef && portalRef.current
      ? createPortal(children, portalRef.current)
      : children;

  return renderInPortal(
    <ChartLegendWrapper
      chartHeight={chartHeight}
      itemsCount={payload.length}
      marginLeft={props.marginLeft}
    >
      {payload.map((payload: any, index: number) => {
        const valueForRender = formatter
          ? formatter(payload.value)
          : payload.value;
        return (
          <ChartLegendItem
            key={index}
            onClick={() => handleClick(payload)}
            onMouseEnter={() => handleMouseEnter(payload, index)}
            onMouseLeave={() => handleMouseLeave(payload, index)}
          >
            <ChartLegendCircle circleColor={payload.color} />
            <ChartLegendLabel>{valueForRender}</ChartLegendLabel>
          </ChartLegendItem>
        );
      })}
    </ChartLegendWrapper>,
  );
};

export default ChartLegentContentComponent;
